var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398 139c5 0 8 3 8 8 0 4-3 8-8 8H8c-4 0-8-4-8-8 0-5 4-8 8-8h390zm0 112c5 0 8 4 8 9 0 4-3 8-8 8H8c-4 0-8-4-8-8 0-5 4-9 8-9h390zm0 113c5 0 8 4 8 8 0 5-3 9-8 9H8c-4 0-8-4-8-9 0-4 4-8 8-8h390zm0-338c5 0 8 4 8 8 0 5-3 8-8 8H8c-4 0-8-3-8-8 0-4 4-8 8-8h390z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.c9d1cabb3a714e5137a6800b07d8c84b.svg";
export { ForwardRef as ReactComponent };